import * as Yup from "yup";

export const formSchema = Yup.object().shape({
    firstName: Yup.string()
        .min(2, 'Imię jest za krótkie.')
        .max(50)
        .matches(/^[\p{L} ]+$/gu, 'Podaj prawidłowe imię.'),
    email: Yup
        .string()
        .email('Ta wartość nie jest prawidłowym adresem email.')
        .max(255).test('is-email-required', 'Ta wartość nie powinna być pusta', function (value) {
            const newsletterAgreement = this.parent.newsletterAgreement;
            const newsletter_info = this.parent.newsletter_info;
            const statute = this.parent.statute;
            if (newsletterAgreement || newsletter_info || statute) return !!value;
            return true;
        }),
    phone: Yup
        .string()
        .required("Ta wartość nie powinna być pusta.")
        .matches(/^\d{9}$/, 'Podaj nr\u00a0telefonu w\u00a0formacie 123456789.')
        .max(9),
    date: Yup
        .string()
        .required('Ta wartość nie powinna być pusta.')
        .notOneOf([''], 'Wybierz termin'),
    hour: Yup
        .string()
        .required('Ta wartość nie powinna być pusta.')
        .notOneOf([''], 'Wybierz godzinę'),
    newsletterAgreement: Yup.boolean(),
    newsletter_info: Yup.boolean(),
    statute: Yup.boolean(),
}).test('allChecked', 'Zaznacz wszystkie pola', function (values) {
    if (
        (values.newsletterAgreement || values.newsletter_info || values.statute) &&
        !(values.newsletterAgreement && values.newsletter_info && values.statute)
    ) {
        return this.createError({
            path: 'statute',
            message: 'Zaznacz pozostałe pola',
        });
    }
});

